import {
  Checkbox,
  ColorValues,
  Flex,
  Spinner,
  Typography,
} from '@banhala/ui-kit';
import { BrandIconTodayShipping } from 'shared/src/component/BrandIcon';
import { useAtom } from 'jotai';
import { localizeNumber } from 'shared/src/utils';
import { likeGoodsFilterAtom } from '../../../states/likeGoodsFilter.atom';
import { useLogClickDeliveryToggle } from '../hooks/useLogClickDeliveryToggle';

interface LikedGoodsCountHeaderProps {
  totalCount: number;
  isLoading?: boolean;
  onPressEdit?: () => void;
}

/**
 * iOS `LikedProductHeaderCell` 대응.
 * 좌: "상품 N개" (로딩 중엔 Spinner), 우: 오늘출발 체크박스 + 편집 버튼.
 */
export const LikedGoodsCountHeader = ({
  totalCount,
  isLoading = false,
  onPressEdit,
}: LikedGoodsCountHeaderProps) => {
  const [filter, setFilter] = useAtom(likeGoodsFilterAtom);
  const logClickDeliveryToggle = useLogClickDeliveryToggle();
  const editDisabled = isLoading || totalCount === 0;

  return (
    <Flex.Row
      alignItems={'center'}
      justifyContent={'space-between'}
      padding={{ horizontal: 16, vertical: 8 }}
      backgroundColor={'bg_primary'}
    >
      {isLoading ? (
        <Spinner size={16} />
      ) : (
        <Flex testID={`찜상품개수?value=${totalCount}`}>
          <Typography type={'body3'} color={'content_tertiary'}>
            상품 {localizeNumber(totalCount)}개
          </Typography>
        </Flex>
      )}
      <Flex.Row alignItems={'center'} gap={4}>
        <Flex testID={`오늘출발토글?value=${filter.isDeliveryFilterOn ? '1' : '0'}`}>
          <Checkbox
            value={filter.isDeliveryFilterOn}
            onPress={() => {
              const next = !filter.isDeliveryFilterOn;
              logClickDeliveryToggle({ isOn: next });
              setFilter(prev => ({ ...prev, isDeliveryFilterOn: next }));
            }}
          />
        </Flex>
        <BrandIconTodayShipping
          width={49}
          height={14}
          color={ColorValues.lilac40}
        />
        <Flex.Row gap={4} alignItems={'center'}>
          <Flex
            width={1}
            height={10}
            backgroundColor={'bg_tertiary'}
            margin={{ horizontal: 8 }}
          />
          <Flex
            padding={{ horizontal: 4 }}
            onPress={editDisabled ? undefined : onPressEdit}
            testID={`편집버튼`}
          >
            <Typography
              type={'subtitle3'}
              color={editDisabled ? 'content_disabled' : 'content_secondary'}
            >
              편집
            </Typography>
          </Flex>
        </Flex.Row>
      </Flex.Row>
    </Flex.Row>
  );
};
